$(function() {
   const recallsForm = $("#recall-form");
   const newsletterForms = $(".contact-form");

   // Custom error placement for validation errors
   function placeValidationError(label, element) {
      label.addClass("form-error-show");
      if (element.is("select")) {
         label.insertAfter(element.next(".ui-selectmenu-button"));
         element.next(".ui-selectmenu-button").addClass("form-invalid");
      } else {
         label.insertAfter(element);
      }
   }

   // Base validation options shared by all forms
   const baseValidationOptions = {
      errorClass: "form-invalid",
      ignore: [],
      errorElement: "div",
      errorPlacement: placeValidationError,
   };

   // Validation for newsletter/contact forms
   newsletterForms.each((_, formElem) => {
      $(formElem).validate({
         ...baseValidationOptions,
         rules: {
            "contact[first_name]": { lettersOnly: true, preventonlywhitespace: true },
            "contact[last_name]": { lettersOnly: true, preventonlywhitespace: true },
            "contact[email]": { customemailvalidation: true },
         },
         messages: {
            "contact[first_name]": { required: window.theme.custom.global.error.required },
            "contact[last_name]": { required: window.theme.custom.global.error.required },
            "contact[email]": window.theme.custom.global.error.email,
         },
         submitHandler(form) {
            hubspotSubmissionGlobal(form, $(formElem), `#${$(formElem).attr("id")}`, ".sk-form-success", ".contact-form");
            return false;
         }
      });
   });

   // Validation for recall form
   recallsForm.validate({
      ...baseValidationOptions,
      rules: {
         fname: { lettersOnly: true, preventonlywhitespace: true },
         lname: { lettersOnly: true, preventonlywhitespace: true },
         email: { customemailvalidation: true },
         address: { noPostOfficeBox: true },
         phone: { digits: true },
         recall_serial_number: { recallFormAllowedSerialNumbers: true },
      },
      messages: {
         fname: { required: window.theme.custom.global.error.required },
         lname: { required: window.theme.custom.global.error.required },
         email: window.theme.custom.global.error.email,
         phone: {
            required: window.theme.custom.global.error.required,
            minlength: window.theme.custom.global.error.min_length,
            digits: window.theme.custom.global.error.please_enter_only_digits,
         },
         recall_serial_number: {
            required: window.theme.custom.global.error.recall_serial_number_required,
            minlength: window.theme.custom.global.error.recall_serial_number_min_length,
            maxlength: window.theme.custom.global.error.recall_serial_number_max_length,
         },
         address: { required: window.theme.custom.global.error.required },
         city: { required: window.theme.custom.global.error.required },
         state: { required: window.theme.custom.global.error.required },
         zip: {
            required: window.theme.custom.global.error.required,
            minlength: window.theme.custom.global.error.min_length,
         },
         recall_purchase_location: { required: window.theme.custom.global.error.required },
         recall_purchase_date: { required: window.theme.custom.global.error.required },
      },
      submitHandler(form) {
         hubspotSubmissionGlobal(form, recallsForm, "#recall-form", ".sk-recall-form-success");
         return false;
      }
   });

   // Main submission function
   function hubspotSubmissionGlobal(form, formId, formClass, formSuccessClass, formClassOverwrite = null) {
      // Helper function to get and title case input values
      function getVal(selector) {
         return formId.find(selector).val();
      }
      function getTitleCase(selector) {
         const val = getVal(selector);
         return val ? titleCase(val) : "";
      }

      const firstName = getTitleCase("#ContactSubscribe-footer-3-first-name, #ContactSubscribe-Popup-first-name, #fname-recall");
      const lastName = getTitleCase("#ContactSubscribe-Popup-last-name, #ContactSubscribe-footer-3-last-name, #lname-recall");
      const email = getVal("#ContactSubscribe-Popup-email, #ContactSubscribe-footer-3-email, #email-recall")?.toLowerCase() || "";
      const address = getVal("#address-recall");
      const city = getVal("#city-recall");
      const state = getVal("#state-recalls");
      const zip = getVal("#zip-recall");
      const phone = getVal("#phone-recall");
      const recallModelNumber = getVal("#model-recall");
      const recallSerialNumber = getVal("#serial-recall");
      const recallPurchaseLocation = getVal("#pop-recall");
      const recallPurchaseDate = getVal("#date-recall");
      const subscribe = formId.find("#subscribe-recall");
      const hutkCookie = getCookieCustom('hubspotutk');

      // Format recall purchase date to yyyy-mm-dd if exists
      let formattedRecallPurchaseDate = "";
      if (recallPurchaseDate?.length) {
         const parts = recallPurchaseDate.split("/");
         if (parts.length === 3) {
            formattedRecallPurchaseDate = `${parts[2]}-${parts[0]}-${parts[1]}`;
         }
      }

      const formData = {
         fields: [
            { name: "firstname", value: firstName },
            { name: "lastname", value: lastName },
            { name: "email", value: email },
            { name: "hs_language", value: Shopify.locale },
            { name: "form_url", value: window.location.origin + window.location.pathname },
         ],
         context: {
            pageUri: window.location.href,
            pageName: document.querySelector('meta[property="og:title"]')?.getAttribute('content') || "",
            ipAddress: locationInfo?.IpAddress || ""
         }
      };

      if (hutkCookie) {
         formData.context.hutk = hutkCookie;
      }

      // Add optional fields if present
      if (address) formData.fields.push({ name: "address", value: address });
      if (city) formData.fields.push({ name: "city", value: city });
      if (state) formData.fields.push({ name: "state", value: state });
      if (zip) formData.fields.push({ name: "zip", value: zip });
      if (phone) formData.fields.push({ name: "phone", value: phone });
      if (recallModelNumber) formData.fields.push({ name: "recall_model_number", value: recallModelNumber });
      if (recallSerialNumber) formData.fields.push({ name: "recall_serial_number", value: recallSerialNumber });
      if (recallPurchaseLocation) formData.fields.push({ name: "recall_purchase_location", value: recallPurchaseLocation });
      if (formattedRecallPurchaseDate) formData.fields.push({ name: "recall_purchase_date", value: formattedRecallPurchaseDate });

      // Determine subscription state
      const isSubscribed = subscribe?.length ? subscribe.is(":checked") : true;

      let formType = "";
      let dataLayerData = {};

      switch (formClass) {
         case "#ContactSubscribe-footer-3":
            formType = "newsletter-footer";
            dataLayerData = { subscribe: isSubscribed, type: formType };
            break;
         case "#ContactSubscribe-Popup":
            formType = "newsletter-modal";
            dataLayerData = { subscribe: isSubscribed, type: formType };
            break;
         case "#recall-form":
            formType = "recall";
            dataLayerData = {
               subscribe: false,
               type: formType,
               recall_model: recallModelNumber,
               recall_pop: recallPurchaseLocation?.toLowerCase(),
               recall_date: formattedRecallPurchaseDate,
            };
            break;
         default:
            errorNotify("SKIL - Form Id Not Found: ", formClass);
            break;
      }

      formData.fields.push({ name: "subscribe", value: isSubscribed });

      const payload = JSON.stringify(formData);

      $.ajax({
         url: $(form).attr('action'),
         type: "POST",
         contentType: "application/json",
         dataType: "json",
         headers: { "accept": "application/json", "Access-Control-Allow-Origin": "*" },
         data: payload
      })
         .done(() => {
            window.dataLayer.push({ event: "FormSubmitSuccess", form_data: dataLayerData });

            const fadeOutTarget = formClassOverwrite || formClass;
            $(fadeOutTarget).fadeOut(() => $(formSuccessClass).fadeIn());
         })
         .fail((error) => {
            try {
               const parsed = JSON.parse(error.responseText);
               if (parsed.errors?.[0]?.errorType === "INVALID_EMAIL") {
                  formId.validate().showErrors({ email: window.theme.custom.global.error.email });
               } else {
                  alert(window.theme.custom.global.error.generic_error);
                  errorNotify(error, $(form).attr('action'));
               }
            } catch {
               alert(window.theme.custom.global.error.generic_error);
               errorNotify(error, $(form).attr('action'));
            }
         });
   }
});